import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaTimesCircle, } from "react-icons/fa";
import ModalCloseIcon from "../../assets/svg/close-modal.svg";
import { ReactComponent as MinusSign } from "../../assets/svg/minus-sign.svg";
import { ReactComponent as PlusSign } from "../../assets/svg/add-circle.svg";
import { Container, Row, Col } from "react-bootstrap";
import len from '../../assets/svg/lentra.svg'
import profile from '../../assets/svg/profile.svg'
import production from '../../assets/svg/production.svg'
import check_failed from '../../assets/svg/druken.svg'
import temp from '../../assets/svg/temp.svg'
import add from '../../assets/svg/add.svg'
import nandhu from '../../assets/svg/nandhu.svg'
import { ReactComponent as ItemNameIcon } from "../../assets/svg/itemname.svg";
import { ReactComponent as QuantityIcon } from "../../assets/svg/Quantity.svg";
import { ReactComponent as DescriptionIcon } from "../../assets/svg/Description.svg";
import { ReactComponent as MoreIcon } from "../../assets/svg/more.svg";
import "./gate-out-modal.css";
import AddItemModal from "./add-item-modal";
import { QRCodeSVG } from "qrcode.react";
import { useReactToPrint } from "react-to-print";
import download from '../../assets/svg/download.svg'
import printimg from '../../assets/svg/print.svg'
import userTemp from '../../assets/png/customer-icon.png'
import { getVisitorDetailsApi, } from "../visitor/visitor-api";
import { getVehicleDetailsApi } from "../vehicle/vehicle-api";


const GenerateQRModal = ({ moduleName, visitorDetails, onCancel, }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [alertItemIndex, setAlertItemIndex] = useState(null);
  const [showAddItemModal, setAddItemModal] = useState(false);
  const [itemData, setItemData] = useState(null);
  const [itemList, setItemList] = useState([]);
  const [visitorData, setVisitorData] = useState({});

  useEffect(() => {
    setVisitorData(visitorDetails)
    if (moduleName === "Visitor") {
      getVisitorDetails();
    }
    if (moduleName === "Vehicle") {
      getVehicleDetails();
    }
  }, [visitorDetails]);
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",

      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "1000px",
      /* height:"500px", */
      overflowY: "auto",
    },
  };


  const getVisitorDetails = async () => {
    try {
      const response = await getVisitorDetailsApi(visitorDetails.id);
      if (response.status === true) {
        setVisitorData(response.visitor ?? {})
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getVehicleDetails = async () => {
    try {
      const response = await getVehicleDetailsApi(visitorDetails.id);
      if (response.status === true) {
        setVisitorData(response.vehicle ?? {})
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const alertRef = useRef(null);
  const getSafeValue = (value) => {
    return value === '' || value === null || value === undefined ? '-' : value;
  };
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleClickOutside = (event) => {
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setAlertItemIndex(null); // Close the alert
    }
  };
  const onSaveItem = (itemData) => {
    setAddItemModal(false);
    const tempItem = [...itemList];
    if (itemData.index === null) {
      tempItem.push(itemData.item)
    } else {
      tempItem[itemData.index] = itemData.item;
    }
    setItemList(tempItem)
  }

  const printRef = useRef(null);
  /*  const downloadQR = () => {
     const canvas = printRef.current.querySelector("canvas");
     const url = canvas.toDataURL("image/png");
     const link = document.createElement("a");
     link.href = url;
     link.download = "qrcode.png";
     link.click();
   }; */
  const downloadQR = () => {
    const svgElement = printRef.current.querySelector('svg');
    const svgData = new XMLSerializer().serializeToString(svgElement);
    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const DOMURL = window.URL || window.webkitURL || window;
    const url = DOMURL.createObjectURL(svgBlob);

    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement('canvas');
      const size = 800; // 🟢 High resolution
      canvas.width = size;
      canvas.height = size;

      const ctx = canvas.getContext('2d');

      // Draw transparent background (optional, it's already transparent by default)
      ctx.clearRect(0, 0, size, size);

      ctx.drawImage(image, 0, 0, size, size);

      // ✅ Convert to PNG and download
      const pngUrl = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.href = pngUrl;
      downloadLink.download = `QR_${visitorData.transaction_id}.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      DOMURL.revokeObjectURL(url);
    };

    image.src = url;
  };
  /*  const handlePrint = useReactToPrint({
     content: () => printRef.current,
     documentTitle: 'QR-Code',
     pageStyle: `
       @page { margin: 0; }
       body { margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; }
     `,
   }); */

  const handlePrint = () => {
    console.log(printRef.current.innerHTM);
    if (printRef.current) {
      const printWindow = window.open('', '_blank');
      printWindow.document.write(`
                  <html>
                    <head>
                      <title>Print QR Code</title>
                    </head>
                    <body style="display: flex; justify-content: center; align-items: center;">
                      ${printRef.current.innerHTML}
                    </body>
                  </html>
                `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
    }
  };
  return (<div style={modalStyle.overlay}>
    {showAddItemModal && <AddItemModal  moduleName={moduleName} itemData={itemData} onSave={onSaveItem} onCancel={() => { setAddItemModal(false); setItemData(null) }} />}
    <div style={modalStyle.modal}>

      <div >
        <div className="modal-header style-justify-between"
        >
          <div className="modal-title"
          >
            Generate QR
          </div>
          <img
            src={ModalCloseIcon}
            alt="Close"
            onClick={onCancel}
            style={{ cursor: "pointer", width: "30px", height: "30px", borderRadius: "50%" }}
          />

        </div>

        <div style={{ display: "flex", gap: "8px" }}>
          {/* Left Section */}
          <div
            style={{
              width: "60%",
              background: "#fff",
              borderRadius: "12px",
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
              padding: "15px",

            }}
          >
            {/* Profile */}
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <img
                src={visitorData.profilephoto !== "" && visitorData.profilephoto ? visitorData.profilephoto : userTemp}
                alt="Profile"
                style={{ width: "40px", height: "40px", borderRadius: "50%" }}
              />
              <div>
                <div className="visitor-name">
                  {visitorData.visitor_name ?? ''} {visitorData.driver_name ?? ''}
                </div>
                {moduleName === "Visitor" && (<div><img src={len} alt="" /> <span className="org-title">{getSafeValue(visitorData.organization)}</span>
                </div>)}
                {moduleName === "Vehicle" && (<div style={{ display: "flex", alignItems: "center", }}>
                  <div className="field-title pt-1">{visitorData.vehicle_number}</div> <span className="dot-span mx-2"></span> <div className="vehicle-type-card px-2 pt-1">{visitorData.vehicle_type}</div>
                </div>)}
              </div>
            </div>

            {/* Info Badges */}
            <div style={{ display: "flex", gap: "10px", marginTop: "12px" }}>
              <div className="in-time-card px-2 py-1"                            >
                <span className="in-time-title">In time</span>
                <div className="font-13-600">
                  {visitorData.in_time ?? ''}
                </div>
              </div>
              {moduleName === "Visitor" && (<div
                className="in-time-card  px-2 py-1"
              >
                <span className="in-time-title">Purpose of visit</span>
                <div className="font-13-600">
                  {visitorData.visit_purpose ?? ''}
                </div>
              </div>)}
            </div>

            {/* Details */}
            <div className="detail-card mt-2"

            >
              <div className="details font-15-700 ">Details</div>
              <div className="px-2 pt-2">
                {moduleName === "Visitor" && (<div className="style-justify-start" style={{ flex: 10 }}>
                  <div style={{ flex: 3 }} className="font-13-400-626F86">Meeting type </div>
                  <div style={{ flex: 7 }} className="font-13-500-172B4D"> {getSafeValue(visitorData.meeting_type)} </div>
                </div>)}
                <div className="style-justify-start  mt-1" style={{ flex: 10 }}>
                  <div style={{ flex: 3 }} className="font-13-400-626F86">Email </div>
                  <div style={{ flex: 7 }} className="font-13-500-172B4D">{getSafeValue(visitorData.email)}</div>
                </div>
                <div className="style-justify-start mt-1" style={{ flex: 10 }}>
                  <div style={{ flex: 3 }} className="font-13-400-626F86">Mobile number </div>
                  <div style={{ flex: 7 }} className="font-13-500-172B4D">{getSafeValue(visitorData.mobile_number)}</div>
                </div>
                <div className="style-justify-start mt-1" style={{ flex: 10 }}>
                  <div style={{ flex: 3 }} className="font-13-400-626F86">Location </div>
                  <div style={{ flex: 7 }} className="font-13-500-172B4D">{getSafeValue(visitorData.location)}</div>
                </div>
                <div className="style-justify-start mt-1" style={{ flex: 10 }}>
                  <div style={{ flex: 3 }} className="font-13-400-626F86">Entry Gate </div>
                  <div style={{ flex: 7 }} className="font-13-500-172B4D">{getSafeValue(visitorData.gate)}</div>
                </div>
                {moduleName === "Visitor" && (<div className="mt-3 mb-2"
                  style={{

                    backgroundColor: "#F9F9F9",
                    padding: "20px",
                    borderRadius: "12px",

                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                    fontFamily: "Arial, sans-serif",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <div style={{ position: 'relative' }}>
                    <div className="w-100 meeting-person-dotted"> </div>
                    <span
                      style={{
                        position: "absolute",
                        top: '-12px',
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "#ffffff",
                        padding: "4px 12px",
                        borderRadius: "12px",
                        fontSize: "12px",
                        color: "#5f6368",
                        fontWeight: "500",
                      }}
                    >
                      Meeting person
                    </span>
                  </div>
                  <div className="style-justify-start mt-3">
                    <img
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        marginRight: "12px",
                        border: "1px solid #e0e0e0",
                      }}
                      src={visitorData.meeting_person_profile ?? userTemp}
                      alt="Profile"
                    />
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#202124",
                          marginBottom: "2px",
                        }}
                      >
                        {getSafeValue(visitorData.meeting_person)} {getSafeValue(visitorData.meeting_person_name)}
                      </span>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "14px",
                          color: "#137333",
                          fontWeight: "500",
                        }}
                      >
                        <img
                          style={{ width: "16px", height: "16px", marginRight: "6px" }}
                          src={production}
                          alt="Briefcase Icon"
                        />
                        {getSafeValue(visitorData.department)}
                      </div>
                    </div>
                  </div>
                </div>)}
              </div>
            </div>

          </div>


          {/* Right Section */}
          <div
            style={{
              width: "40%",
              background: "#fff",

              padding: "12px",
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
              textAlign: 'center'
            }}
          >
            <div className="heading-title font-15-700 mb-2">
              QR code
            </div>
            <div ref={printRef} style={{ textAlign: "center", }}>
              <QRCodeSVG
                value={visitorData.transaction_id ?? ''}
                size={180}
                bgColor="#ffffff"
                fgColor="#000000"
                level="H"
                includeMargin={true}
              />
            </div>
            <div style={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: "center", gap: "10px" }}>
              <button
                onClick={downloadQR}
                className="download-btn px-3"
              >
                <img src={download} alt="" /> Download
              </button>
              <button
                onClick={handlePrint}
                className="download-btn px-4"
              >
                <img src={printimg} alt="" /> Print
              </button>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>);

}

export default GenerateQRModal;